export const SERIE_INVALID = 'invalid';

export const SERIE_SUCCESS = 'success';
